import { useQuery } from '@tanstack/react-query';
import { Megaphone } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@mlm/ui';
import { announcementImageUrl, listAnnouncements } from '../../lib/api';

function formatDate(iso: string | null): string {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

/**
 * Dashboard card listing admin-authored announcements (published, non-expired).
 * Renders nothing when there are none, so it never adds empty chrome.
 */
export function AnnouncementsPanel() {
  const q = useQuery({ queryKey: ['me-announcements'], queryFn: listAnnouncements });
  const items = q.data ?? [];
  if (items.length === 0) return null;

  return (
    <Card>
      <CardHeader className="flex-row items-center gap-2 space-y-0">
        <Megaphone className="h-5 w-5 text-o" />
        <CardTitle>Announcements</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {items.map((a) => (
          <div key={a.id} className="space-y-1 border-b pb-4 last:border-b-0 last:pb-0">
            <div className="flex items-baseline justify-between gap-2">
              <h3 className="font-semibold">{a.title}</h3>
              <span className="flex-none text-xs text-muted-foreground">
                {formatDate(a.publishedAt)}
              </span>
            </div>
            {a.imageUrl && (
              <img
                src={announcementImageUrl(a.id)}
                alt=""
                className="max-h-56 w-full rounded-md object-cover"
              />
            )}
            <p className="whitespace-pre-wrap text-sm text-muted-foreground">{a.body}</p>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
